import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Guide from '../Guide/Application-Guidelines-for-CSR-Schloarship-form.pdf'
import CloseIcon from "@mui/icons-material/Close";

const Popup = () => {
  const [open, setOpen] = useState(false);

  // Open the popup when the component mounts (i.e., when the form opens)
  useEffect(() => {
    setOpen(true);
  }, []);

  const handleClose = () => setOpen(false);

  return (
    <div>
      {/* Your form goes here */}

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          Application Guidelines
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon /> 
          </IconButton>
        </DialogTitle>
        <div style={{ height: "80vh", overflow: "hidden" }}>
          <iframe
            src={Guide}
            title="Application Guidelines"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </div>
      </Dialog>
    </div>
  );
}
export default Popup;